import { connect } from 'react-redux';

import {
  getMetaDataDescription,
  getMetaDataKeywords,
  getMetaDataNoIndex,
  getMetaDataTitle,
} from 'redux/modules/search-and-browse/selectors/meta-data';
import { getPageTitle } from 'redux/modules/search-and-browse/selectors';

import MetaHeader from 'components/MetaHeader';

export default connect(state => ({
  description: getMetaDataDescription(state),
  keywords: getMetaDataKeywords(state),
  notIndexed: getMetaDataNoIndex(state),
  pageTitle: getPageTitle(state),
  title: getMetaDataTitle(state),
}))(MetaHeader);
